import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { formatDate, Logger } from '@footsteps/shared';
import App from './App';
import './index.css';

const logger = new Logger('App');

declare const __BUILD_DATE__: string;
logger.info(`Build: ${formatDate(__BUILD_DATE__)}`);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
